import Helper from '@ember/component/helper';
import { getOwner } from '@ember/owner';
import type UserService from 'walden-fast/services/user';
import type { ServiceName } from 'walden-fast/utils/constants/services';

export default class CanAccessViewHelper extends Helper {
  compute([serviceName]: [ServiceName]) {
    if (!serviceName) {
      return false;
    }

    const userService = getOwner(this)?.lookup('service:user') as UserService;

    if (!userService) {
      return false;
    }

    return userService.canAccessService(serviceName);
  }
}
